import React, { useContext } from "react";
import { Link } from 'react-router-dom';
import { AppContext } from "../App";
import { getBlogExcerpt, getImageUrl, getSafeDateLabel } from "../pages/homepageUtils";


export default function BlogListsBlog({ bloglistsblog = [], currentId }) {

    const strapiURL = useContext(AppContext)
    if (!bloglistsblog ) {
        return null; 
    }

return (
  <div className="retro-related-list">
    {bloglistsblog
      .filter((item) => item?.documentId !== currentId)
      .map((item) => {
      const imageUrl = getImageUrl(item, strapiURL);

      return (
        <Link to={`/blog/${item?.documentId}`} className="retro-related-row" key={item?.id || item?.documentId}>
          <div className="retro-related-thumb">
            {imageUrl ? (
              <img src={imageUrl} alt={item?.Title} />
            ) : (
              <span>LOG</span>
            )}
          </div>
          <div>
            <span>{getSafeDateLabel(item?.Date)}</span>
            <h3>{item?.Title}</h3>
            <p>{getBlogExcerpt(item?.Body, 72)}</p>
          </div>
        </Link>
      );
    })}
  </div>
);

}
